<template>
  <div class="h-full max-w-300 mx-auto md:mx-0 md:max-w-full md:pl-100 pt-35 md:pt-67 text-app-color">
    <div class="flex items-center md:hidden" @click="back">
      <i class="text-12 mr-10 icon-keyboard-arrow-left opacity-50" />
      <p class="text-opacity-80">Back</p>
    </div>

    <p class="text-35 md:text-21 font-bold">Preferences</p>

    <p class="text-16 font-bold mt-30 my-5">Checkboxes</p>
    <CheckboxModule
      :model-value="isTaskOrdering"
      label="Auto-fold completed checkboxes"
      @update:modelValue="toggleAutoFold"
    />

    <p class="text-16 font-bold mt-30 my-5">Grammar check</p>
    <CheckboxModule
      :model-value="isGrammarCheck"
      label="Grammar check (browser default)"
      @update:modelValue="toggleGrammarCheck"
    />

    <p class="text-16 font-bold mt-30 my-5">Theme</p>
    <CheckboxModule
      :model-value="isAutoSwitchingThemeEnable"
      label="Enable dark or light mode depending on your system settings"
      @update:modelValue="toggleEnableAutoSwitchingTheme"
    />

    <p class="text-16 font-bold mt-30 my-5">Date format</p>
    <SelectModule
      :model-value="dateFormat"
      class="text-14 w-200 rounded-4"
      :options="options"
      @update:modelValue="updateFormat"
    />
  </div>
</template>

<script>
import CheckboxModule from '@/components/shared/form-controls/CheckboxModule'
import SelectModule from '@/components/shared/form-controls/SelectModule'

import { mapGetters, mapState, mapMutations } from 'vuex'

import { settingsService } from '@/services'

export default {
  name: 'Preferences',

  components: {
    CheckboxModule,
    SelectModule
  },

  emits: ['back'],

  data () {
    return {
      options: [
        { id: 1, name: 'DD.MM.YYYY' },
        { id: 2, name: 'DD-MM-YYYY' },
        { id: 3, name: 'MM/DD/YYYY' },
        { id: 4, name: 'MM.DD.YYYY' },
        { id: 5, name: 'YYYY/MM/DD' }
      ]
    }
  },

  computed: {
    ...mapGetters(['isDarkMode']),
    ...mapState({
      isGrammarCheck: state => state.settings.isGrammarCheck,
      isTaskOrdering: state => state.settings.settings.taskOrdering,
      dateFormat: state => state.settings.dateFormat,
      settings: state => state.settings.settings,
      isAutoSwitchingThemeEnable: state => state.settings.isAutoSwitchingThemeEnable
    })
  },

  methods: {
    ...mapMutations(['updateGrammarCheck', 'updateAutoFold', 'setNotification', 'updateSettings', 'updateAutoSwitchingTheme', 'updateDateFormat']),

    back () {
      this.$emit('back')
    },

    toggleGrammarCheck () {
      this.updateGrammarCheck(!this.isGrammarCheck)
    },

    toggleAutoFold (value) {
      const design = { ...this.settings }
      design.taskOrdering = value

      this.updateSettings(design)
      settingsService.update({ taskOrdering: value })
    },

    toggleEnableAutoSwitchingTheme () {
      this.updateAutoSwitchingTheme(!this.isAutoSwitchingThemeEnable)
    },

    updateFormat (format) {
      this.updateDateFormat(format)
    }
  }
}
</script>
